/*
 * @Author: wangzhijun wangzhijun@dataoceanai.com
 * @Date: 2022-10-18 14:04:23
 * @LastEditors: wangzhijun wangzhijun@dataoceanai.com
 * @LastEditTime: 2022-10-21 13:52:26
 * @FilePath: \supplier_side\src\services\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { post, get, put, del } from "@/utils/request";

// 获取OSS签名
export function getSign(first = "", second = "") {
    return get(
        `/api/external-interface/oss/getSign?first=${first}&second=${second}`
    );
}

//登录
export function login(data) {
    return post("/api/auth-sign-java/accountClient/login", data);
}

//登录
export function login1(data) {
    return post("/api/dots-platform/login", data);
}

//退出登录
export function loginOutApi1() {
    //退出登录清除token
    const date = new Date("Fri, 31 Dec 9999 23:59:59 GMT");
    document.cookie = "dots-token=; expires=" + date.toUTCString() + ";path=/;domain=.dataoceanai.com";
    return get("/api/dots-platform/loginAccount/logout");
}

// 注册
export function register(data) {
    return post("/api/auth-sign-java/accountClient/doregist", data);
}

// 用户注册
export function register1(data) {
    return post("/api/dots-platform/user", data);
}

// 更改密码
export function changePasswordByToken(data) {
    return post("/api/auth-sign-java/accountClient/changePasswordByToken", data);
}

// 更改密码1
export function changePasswordByToken1(data) {
    return post("/api/dots-platform/personalCenter/changePassword", data);
}

// 忘记密码
export function forgotPassword(data) {
    return post("/api/dots-platform/loginAccount/forgotPassword", data);
}

// 发送验证码(废弃)
export function sendVerifyCode(data) {
    return post("/api/auth-sign-java/accountClient/sendVerifyCode", data);
}

// 发送验证码（最新）
export function sendVerifyCode1(data) {
    return get("/api/external-interface/notic/sendVerifyCode", data);
}

// 账号查重
export function isRepeatAccount(data) {
    return get(`/api/dots-platform/loginAccount/isRepeatAccount`, data);
}

// 选择用户
export function loginAccountChoice(infoId) {
    return get(`/api/dots-platform/loginAccount/choice?infoId=${infoId}`);
}

// 验证验证码
export function checkAccountByVerifyCode(data) {
    return post(
        "/api/auth-sign-java/accountClient/checkAccountByVerifyCode",
        data
    );
}

// 验证验证码1
export function checkAccountByVerifyCode1(data) {
    return get("/api/external-interface/notic/checkVerifyCode", data);
}

// 获取token
export function getAccountPasswordChangeToken(data) {
    return get(
        "/api/auth-sign-java/accountClient/getAccountPasswordChangeToken",
        data
    );
}

//按钮权限接口
export function getButtonApi(pageName) {
    return get(`/api/auth-sign-java/admin/getButton?pageName=${pageName}`);
}

//团队管理模块字典值
export function getTypeApi(type) {
    return get(`/api/auth-sign-java/attr/${type}`);
}

//字典值
export function getTypeV2Api(type) {
    return get(`/api/auth-sign-java/attr/v2?groupCodes=${type}`);
}

//海外国家
export function getCountriesApi(type) {
    return get(`/api/auth-sign-java/address/${type}`);
}

//问题反馈
export function feedback(data) {
    return post(`/api/auth-sign-java/feedback`, data);
}

//校验密码
export function checkPassword(data) {
    return post(`/api/auth-sign-java/accountClient/checkPassword`, data);
}

//修改账号
export function changeAccount(data) {
    return post(`/api/auth-sign-java/accountClient/changeAccount`, data);
}

//删除账户
export function deleteAccount(verifyCode) {
    return del(`/api/auth-sign-java/accountClient?verifyCode=${verifyCode}`);
}

//修改密码 （上面有修改密码了，估计后台接口写重了）
export function changePassword(data) {
    return post(`/api/auth-sign-java/accountClient/changePassword`, data);
}

//获取用户信息
export function getUserInfo(data) {
    return get(`/api/auth-sign-java/accountClient/getUserInfo`, data);
}

// 检查账号是否存在
export function checkAccountExist(data) {
    return get(`/api/auth-sign-java/accountClient/checkAccountExist`, data);
}

// 手机号、邮箱 用户认证
export function verifyApi(data) {
    return post(`/api/dots-platform/user/verify`, data);
}

// 点击跳转其他系统的时候。生成UUID
export function genTokenIdApi() {
    return get(`/api/dots-platform/home/genTokenId`);
}

// 根据登录角色 DM-PM。获取当前部门下的所有PM
export function myPmsApi(data) {
    return get(`/api/dots-platform/pm/myPms`);
}

//模糊匹配签署方
export function getsigntorysApi(data) {
    return post(`/api/auth-sign-java/match/getsigntorys`, data);
}

//劳务团队列表
export function getLabourSupplierListApi() {
    return get(`/api/procurement/procurementFinalist/getLabourSupplierList`);
}

//AD对接团队验证账号
export function checkAccount(bindId, data) {
    return post(`/api/dots-platform/team/checkAccount?bindId=${bindId}`, data);
}
//AD对接团队搜索账号
export function searchAccount(bindId, data) {
    return get(`/api/dots-platform/team/search?bindId=${bindId}`, data);
}
//AD对接团队启用账号
export function activateAccount(bindId, data) {
    return post(`/api/dots-platform/team/activateAccount?bindId=${bindId}`, data);
}

//AD注册团队账号
export function adRegist(bindId, data) {
    return post(`/api/dots-platform/team/adRegist?bindId=${bindId}`, data);
}